import { useAuthentication } from '@/contexts/dataSync/AuthenticationContext';
import { Stack } from '@mui/material';
import { Button, HSpacer, Text, VSpacer } from '@/components/DesignSystem';
import { AxiomLogo } from '@/components/DesignSystem/Logo/AxiomLogo';
import { InsightChurnPieChartSection } from '@/pages/Insights/InsightChurnPieChartSection';
import { InsightsChurnTableSection } from '@/pages/Insights/InsightsChurnTableSection';
import Insights from '@mui/icons-material/Insights';
import { useState } from 'react';
import beta from '@/assets/icons/beta.svg';
import { AboutInsightsModal } from '@/components/shared/AboutInsightsModal';
import { useProgramPeriodSelector } from '@/hooks/useProgramPeriodSelector';
import { useTranslation } from 'react-i18next';



const RetailerInsight = () => {
  const { t } = useTranslation();
  const { retailer } = useAuthentication();
  const [showAboutInsightsModal, setShowAboutInsightsModal] = useState<boolean>(false);
  
  const { selectedProgramPeriod } = useProgramPeriodSelector({
    rewardsPrograms: retailer?.rewardsPrograms,
  });
  
  return (
    <Stack alignItems="center">
      <Stack maxWidth="1216px" width="100%">
        <VSpacer size="4" />
        <Stack
          alignItems="flex-end"
          direction="row"
          height="44px"
          justifyContent="space-between"
        >
          <Stack alignItems="center" direction="row">
            <Text category="h2">{t($ => $.insights.title)}</Text>
            <HSpacer size="4" />
            <img
              alt="Beta"
              height="16"
              src={beta}
              style={{ marginTop: '3px' }}
            />
          </Stack>
          <Stack alignItems="center" direction="row">
            <Button
              onClick={() => setShowAboutInsightsModal(true)}
              size="medium"
              startIcon={<Insights />}
              sx={{ "letter-spacing": "0.1px" }}
              testID="about-insight-button"
              variant="text"
            >
              {t($ => $.insights.about)}
            </Button>
            <HSpacer size="2" />
            <AxiomLogo />
          </Stack>
        </Stack>
        <VSpacer size="7" />
        {!!retailer && (
          <InsightChurnPieChartSection
            retailerId={retailer.id}
          />
        )}
        <VSpacer size="7" />
        {!!retailer && !!selectedProgramPeriod && (
          <InsightsChurnTableSection
            program={selectedProgramPeriod}
            retailerId={retailer.id}
          />
        )}
      </Stack>
      {showAboutInsightsModal && (
        <AboutInsightsModal
          onClose={() => setShowAboutInsightsModal(false)}
          open={true}
        />
      )}
    </Stack>
  );
};

export default RetailerInsight;
